/**
 * Lazy route registration for the templates feature (Plan 02-06 Task 2).
 *
 * The list page + editor are full-page surfaces (not dialogs — UI-SPEC §Surface 1
 * notes the editor has too much content for a dialog). Both lazy-chunked; the
 * shared i18n preload from ``lib/i18n.ts`` keeps DE/ES correct on first nav
 * (BUG-003).
 */
import { lazy } from "react";

export const TemplateListRoute = lazy(() =>
  import("@/features/templates/TemplateListPage").then((m) => ({
    default: m.TemplateListPage,
  })),
);

export const TemplateEditorRoute = lazy(() =>
  import("@/features/templates/TemplateEditorPage").then((m) => ({
    default: m.TemplateEditorPage,
  })),
);
